
import { defineComponent } from 'vue';
import { TagData, Topic } from '@/types';
import { store } from '@/state';
import { twitch } from '@/twitch-instance';
import TagsInput from '@voerro/vue-tagsinput';
import { convertTwitchTagsToTagData, generateNotification, generateTitle } from '@/utils';
import ScrollingContent from '@/components/ScrollingContent.vue';

export default defineComponent({
  components: {
    ScrollingContent,
    TagsInput
  },
  props: {
    topic: {
      type: Object as () => Topic,
      required: true
    },
    loggedIn: {
      type: Boolean
    }
  },
  data () {
    return {
      workingTopic: { ...this.topic } as Topic,
      counterPlaceholder: '{{counter}}',
      currentTags: [] as TagData[],
      state: store.state,
      customChannel: !!this.topic?.customChannel
    }
  },
  computed: {
    allTags (): TagData[] {
      const allTags = [...Object.values(this.state.tags)];

      if (this.workingTopic?.importTags) {
        allTags.push(...this.workingTopic.importTags);
      }

      return allTags;
    },
    generatedTitle (): string {
      return generateTitle({
        ...this.workingTopic
      });
    },
    generatedNotification (): string {
      return generateNotification({
        ...this.workingTopic
      });
    },
    isTemplateInvalid (): boolean {
      return this.notValidTemplateExplanation !== '';
    },
    notValidTemplateExplanation (): string {
      const template = this.workingTopic.template;

      if (!template) {
        return 'You need a template.';
      }

      const generatedTitle = generateTitle({
        ...this.workingTopic,
        currentCounter: 100
      });

      const titleLength = generatedTitle.length;

      if (titleLength > 140) {
        return `A generated topic can be only 140 characters long. (Using 100 as counter) - Current Length: ${titleLength}`;
      }

      return '';
    },

    isNotificationInvalid (): boolean {
      return this.notValidNotificationExplanation !== '';
    },
    notValidNotificationExplanation (): string {
      const template = this.workingTopic.notificationText;

      if (!template) {
        return 'You need a going live notification.';
      }

      const generatedTitle = generateTitle({
        ...this.workingTopic,
        currentCounter: 100
      });

      const titleLength = generatedTitle.length;

      if (titleLength > 140) {
        return `A generated notification can be only 140 characters long. (Using 100 as counter) - Current Length: ${titleLength}`;
      }

      return '';
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel');
    },
    save () {
      if (!this.workingTopic.title) {
        return;
      }

      if (this.isTemplateInvalid) {
        return;
      }

      this.$emit('save', this.workingTopic);
    },
    async importFromTwitch () {
      const channelInfo = await twitch.currentChannelInformation();
      const tags = await twitch.currentTags();

      if (!this.workingTopic.template) {
        this.workingTopic.template = channelInfo.title;
      }

      this.workingTopic.gameId = channelInfo.game_id;
      this.workingTopic.gameName = channelInfo.game_name;

      console.info({ channelInfo, tags });

      const importedTags = convertTwitchTagsToTagData(tags);

      console.info({ tags, importedTags });
      this.workingTopic.importTags = importedTags;

      this.currentTags = importedTags;
    },
    updateTagsFromTopic () {
      // topic was changed
      // set the current tags from the Topic
      console.info({
        topic: this.workingTopic,
        state: JSON.stringify(this.state.tags) ?? 'no null value',
        test: true
      });

      this.currentTags = this.workingTopic.tags
        ?.split(',')
        .map(id => this.state.tags[id])
        .filter(t => !!t) ?? [];

      this.updateTagsToTopic();
    },
    updateTags () {
      const tagsValue = (this.$refs as any).tagsInput.tags;

      this.currentTags = tagsValue;

      console.info(this.$refs);
      console.info('SHOULD BE UPDATED?!!?', this.currentTags);

      this.updateTagsToTopic();
    },
    updateTagsToTopic () {
      this.workingTopic.tags = this.currentTags.map(t => t.id).join(',');
    },
    addCommand () {
      this.workingTopic.commands.push({
        name: 'New Command',
        content: ''
      });
    },
    removeCommand (index: number) {
      this.workingTopic.commands.splice(index, 1);
    },
    archiveTopic () {
      this.workingTopic.archived = true;
      this.save();
    }
  },
  watch: {
    topic (val) {
      this.workingTopic = { ...val } as Topic;

      this.updateTagsFromTopic();
    }
  },
  mounted () {
    this.updateTagsFromTopic();
  }
})
